import { Card, Descriptions, Row, Typography } from 'antd';
import React from 'react';
import {
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment,
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment
} from '../../../../../../generated';

export interface PrivateCaseDetailsSummaryProps {
  caseDetailsData: CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment;
  privateCaseDetails: CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment;
}

export const PrivateCaseDetailsSummary: React.FC<PrivateCaseDetailsSummaryProps> = (props) => {
  return (
    <div>
      <Card>
        <Row gutter={[5, 5]}>
          <Descriptions layout="vertical" title={<Typography.Text style={{ fontSize: '20px' }}>Private Case Details</Typography.Text>}>
            <Descriptions.Item label="Institution Email">{props?.privateCaseDetails?.institutionContactDetails?.institutionEmail || 'N/A'}</Descriptions.Item>
            <Descriptions.Item label="Institution Phone">{props?.privateCaseDetails?.institutionContactDetails?.institutionPhone || 'N/A'}</Descriptions.Item>
          </Descriptions>
          <Descriptions layout="vertical" title={<Typography.Text style={{ fontSize: '16px' }}>Alternate verifying entity</Typography.Text>} style={{ marginTop: 15 }}>
            <Descriptions.Item contentStyle={{ paddingLeft: '18px' }}>
              <Typography.Text style={{ marginTop: -10 }}>{props?.privateCaseDetails?.alternativeVerifyingEntity?.otherDetails || 'N/A'}</Typography.Text>
            </Descriptions.Item>
          </Descriptions>
          <Descriptions style={{marginTop: 15}} layout="vertical" title={<Typography.Text style={{ fontSize: '16px' }}>Credential Verification Rejection Details</Typography.Text>}>
            <Descriptions.Item>{props?.caseDetailsData?.applicationReview?.decision?.rejectionReason || 'N/A'}</Descriptions.Item>
          </Descriptions>
          <Descriptions style={{marginTop: 15}} layout="vertical" title={<Typography.Text style={{ fontSize: '16px' }}>Verification Status</Typography.Text>}>
            <Descriptions.Item label="Verification Response" labelStyle={{marginTop: -10}}>{props?.privateCaseDetails?.verificationStatus?.verificationResponse || 'N/A'}</Descriptions.Item>
          </Descriptions>
        </Row>
      </Card>
    </div>
  );
};
